import React from "react";
import Button from "@shared/v2/Button";
import ZoomCard from "./shared/ZoomCard";

const OpportunitiesCard = () => (
  <ZoomCard
    actions={
      <Button size="medium" schema="secondary" onClick={() => {}}>
        Get Notified
      </Button>
    }
    title="Opportunities"
    comingSoon
    description="Be the first to reach out with extensive prospecting data for Expireds, FSBO’s, and Pre-foreclosure leads."
    imgSrc="/images/bg-card-opportunities.png"
    imgClassName="tw-mx-[12px]"
  />
);

export default OpportunitiesCard;
